var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuPostPublished(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36.97 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8,11.25V30.73A1.27,1.27,0,0,0,9.28,32H35.05a1.27,1.27,0,0,0,1.27-1.27V23.87H33.78v5.59H10.55V13.39h9.58a1.27,1.27,0,0,0,1.27-1.27V2.54H33.78V8.2h2.54V1.27A1.27,1.27,0,0,0,35.05,0H19.21a1.28,1.28,0,0,0-.9.37l-9.93,10A1.27,1.27,0,0,0,8,11.25Zm3.47-.4,7.38-7.42v7.42Z",
    transform: "translate(-8)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.65,17.24h11L38,19.9a1.26,1.26,0,0,0,1.78,1.78l4.81-4.81a1.24,1.24,0,0,0,0-1.78L44.54,15l-4.76-4.76A1.26,1.26,0,0,0,38,12.06l2.66,2.66h-11a1.26,1.26,0,0,0,0,2.52Z",
    transform: "translate(-8)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuPostPublished);
export default __webpack_public_path__ + "static/media/menu-post-published.6ec04240.svg";
export { ForwardRef as ReactComponent };